import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable Project Promotr, referring consumer traffic to retailer websites.
 * https://www.notion.so/faire/Project-Promotr-Monetizing-consumer-traffic-1532efb5c25a804d9b72dbb1a132cbbb
 * We are aiming to refine and launch this feature in H2 2025, so we will leave the code in place as a starting
 * point for that work.
 */
export const ENABLE_PROJECT_PROMOTR_CONSUMER_REFERRALS_241216 =
  'ENABLE_PROJECT_PROMOTR_CONSUMER_REFERRALS_241216' as SettingConst<
    'ENABLE_PROJECT_PROMOTR_CONSUMER_REFERRALS_241216',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
